/* The mockup's "Gasto diario" card: a head with the unit and the table toggle, then the SVG chart. */
.card {
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-block-size: 48px;
  padding: var(--space-2) var(--space-4);
  border-block-end: 1px solid var(--border);
}

.title {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.unit {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.spacer {
  flex: 1;
}

.chart {
  padding: var(--space-2) var(--space-4) var(--space-4);
}

.svg {
  display: block;
  inline-size: 100%;
  block-size: auto;
}

.grid {
  stroke: var(--border);
  stroke-width: 1;
}

.axis {
  fill: var(--text-subtle);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
}

.bar {
  fill: var(--action-surface);
}

.bar:hover {
  fill: var(--action-surface-hover);
}

.tableWrap {
  overflow-x: auto;
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-4);
  border-block-end: 1px solid var(--border);
  text-align: start;
}

.table thead th {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
}

.table tbody th {
  font-weight: var(--font-weight-regular);
}

.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-block-end: 0;
}

.table .number {
  text-align: end;
  font-variant-numeric: tabular-nums;
}
